// extracted by mini-css-extract-plugin
export default {"loaderContainer":"AnimatedTextLoader_loaderContainer__BQkR-","letter":"AnimatedTextLoader_letter__gf-vT"};